import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";

const mvSwiper = new Swiper(".mvSwiper", {
    slidesPerView: "auto",
    speed: 1000,
    autoplay: {
        delay: 4000,
        waitForTransition: true,
    },
    freeMode: true,
    loop: true,
    modules: [Autoplay],
    allowTouchMove: false,
});

const conceptSwiper = new Swiper(".conceptSwiper", {
    slidesPerView: "auto",
    speed: 600,
    autoplay: {
        delay: 2500,
        waitForTransition: true,
    },
    freeMode: true,
    loop: true,
    modules: [Autoplay],
});

const bigConceptSwiper = new Swiper(".bigConceptSwiper", {
    slidesPerView: "auto",
    speed: 600,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    loop: true,
    modules: [Navigation],
});

const liveSwiper = new Swiper(".liveSwiper", {
    slidesPerView: "auto",
    speed: 600,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    loop: true,
    modules: [Navigation],
});

const pageSwiper = new Swiper(".pageSwiper", {
    slidesPerView: "auto",
    speed: 600,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    loop: true,
    modules: [Navigation],
});
